export default "__VITE_ASSET__e987c6a1__"